import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as AuthActions from '../../../store/actions/auth.action';
import { ConfirmInvitationApiService } from '../confirm-invitation.api.service';
import { ConfirmInvitationFacadeService } from './confirm-invitation-facade.service';

import * as ConfirmInvitationActions from './confirm-invitation.actions';

@Injectable({ providedIn: 'root' })
export class ConformInvitationEffects {

    constructor(private _actions$: Actions,
        private _confirmInvitationApiService: ConfirmInvitationApiService,
        private _confirmInvitationFacadeService: ConfirmInvitationFacadeService) {
    }

    fetchConfirmationUrl$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(ConfirmInvitationActions.fetchConfirmationSettings),
            switchMap(({ apiUrl }) => this._confirmInvitationApiService.getConfirmationSettings(apiUrl).pipe(
                map(result => ConfirmInvitationActions.fetchConfirmationSettingsSucceeded(result)),
                catchError(error => of(ConfirmInvitationActions.fetchConfirmationSettingsFailed(error)))
            )
            )
        );
    });


}
